import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Drawer, Divider, Typography, Descriptions, Row, Col, Spin, Tag } from "antd";
import { isMobile } from "react-device-detect";
import { isValidDate, renderLaboCaseStatusTag } from "@/utils/helpers";
import ImageListDisplay from "@/components/images/ImageListDisplay";
import NoteAlert from "@/components/NoteAlert";
import PopupWrapper from "@/components/PopupWrapper";
import LaboCaseForm from '@/routes/labo-cases/LaboCaseForm';
import { fetchLaboCaseDetail } from '@/redux/actions/laboCaseActions';
import { checkPermission } from "@/utils/permission";

const { Paragraph } = Typography;

function LaboCaseDetail({ visible, currentItem, onCancel, loadData, detailLoading }) {
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [modalMode, setModalMode] = useState('edit');
    const [currentEditItem, setCurrentEditItem] = useState(null);

    const routeName = 'labo_cases';
    const allowUpdate = checkPermission(routeName, 'update');

    const dispatch = useDispatch();

    const openModal = (mode = 'edit', item = null) => {
        setIsOpenModal(true);
        setModalMode(mode);
        setCurrentEditItem(item);
    };

    const onEdit = async (id) => {
        setIsLoading(true);
        const res = await dispatch(fetchLaboCaseDetail(id));
        openModal('edit', res);
        setIsLoading(false);
    };

    const handleClose = () => {
        setIsLoading(false);
        onCancel();
    };

    const serviceList = (currentItem?.customer_services || [])
        .map((item) => item?.service?.name || item?.name)
        .filter(Boolean)
        .join(", ");

    return (
        <>
            <Drawer
                visible={visible}
                title={`Chi tiết #${currentItem?.id}`}
                width={isMobile ? "100%" : "60%"}
                onClose={handleClose}
                maskClosable={false}
                destroyOnClose
                extra={
                    <div style={{ textAlign: 'right' }}>
                        <Divider type="vertical" />
                        <Button disabled={!allowUpdate} loading={isLoading} type="primary" onClick={() => onEdit(currentItem?.id)}>
                            Cập nhật
                        </Button>
                    </div>
                }
                footer={false}
            >
                {visible && (
                    <Spin tip="Loading..." spinning={detailLoading}>
                        <Row gutter={16}>
                            <Col xs={24}><NoteAlert className="mb-3" showIcon={false} note={currentItem?.note} type="warning" /></Col>

                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Tên khách hàng">{currentItem?.customer?.full_name}</Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>

                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Mã khách hàng">
                                <Paragraph style={{ margin: 0 }} copyable={{ text: currentItem?.customer?.code, tooltips: false }}>
                                    <Tag>{currentItem?.customer?.code}</Tag>
                                </Paragraph>
                            </Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>

                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Dịch vụ">{serviceList || <i style={{ color: "#999" }}>Không có</i>}</Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>

                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Labo">{currentItem?.labo?.name}</Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>
                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Thời gian bảo hành">{currentItem?.warranty_period} (tháng)</Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>
                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Ngày gửi">{isValidDate(currentItem?.send_date, false)}</Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>
                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Ngày nhận">{isValidDate(currentItem?.receive_date, false)}</Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>
                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Ngày trả">{isValidDate(currentItem?.return_date, false)}</Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>

                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Trạng thái">{renderLaboCaseStatusTag(currentItem?.status)}</Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>

                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Ngày tạo">{isValidDate(currentItem?.created_at, true)}</Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>
                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Người tạo">{currentItem?.created_user?.full_name}</Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>

                            <Col xs={24}><Descriptions size="small"><Descriptions.Item label="Ảnh giao nhận">
                                <ImageListDisplay images={currentItem?.images} width={80} height={80} />
                            </Descriptions.Item></Descriptions><Divider className='no-margin' /></Col>
                        </Row>
                    </Spin>
                )}
            </Drawer>

            <PopupWrapper
                mode={modalMode}
                visible={isOpenModal}
                currentItem={currentEditItem}
                onCancel={() => setIsOpenModal(false)}
                loadData={loadData}
                FormComponent={LaboCaseForm}
            />
        </>
    );
}

export default LaboCaseDetail;
